
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
const DefaultAvatar = require('@/assets/leaky_hunter_icon_small.png')

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }

  get device(): string {
    return AppModule.device.toString()
  }

  get avatar(): string {
    // return UserModule.avatar
    // // console.log(DefaultAvatar)

    // return avatar + "?imageView2/1/w/80/h/80"
    return DefaultAvatar
  }

  get currentOrg() {
    return UserModule.currentOrg
  }

  get hasMultipleOrgs(): boolean {
    return UserModule.orgs && UserModule.orgs.length > 1
  }

  public toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  public switchOrg() {
    this.$router.push('/select_org')
  }

  public async logout() {
    await UserModule.LogOut()

    // // console.log('现在登出了，跳转到登录页 /login?redirect=' + this.$route.fullPath + '')
    this.$router.push('/login?redirect=' + this.$route.fullPath)
  }
}
